// extracted by mini-css-extract-plugin
module.exports = {"nav_wrapper":"Navigation_nav_wrapper__25iKs","nav_link":"Navigation_nav_link__2eV-k","active_link":"Navigation_active_link__1lqt5"};